import React from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import {
  DomainObject,
  FormCustomField,
  FormPanel,
  FormTextField,
  TextArea,
  Tooltip,
  useFormSelector,
} from '@eas/common-web';
import { Redirect } from '@composite/redirect/redirect';
import { CourtFile, Document, InfFile, SprFile } from '@models';
import { Agenda, EvidenceBrowserUrl } from '@enums';

function FormattedList({
  items,
}: {
  items: (DomainObject & { label?: string })[];
}) {
  const MAX_ROWS = 5;
  const count = items.length;

  return (
    <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
      {items.slice(0, MAX_ROWS)?.map((item) => (
        <Typography key={item?.id}>{item?.label ?? '--'}</Typography>
      ))}
      {count > MAX_ROWS ? (
        <Tooltip
          type="CLICKABLE"
          title={
            <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
              <pre>
                {items
                  .slice(MAX_ROWS)
                  .map((item) => item?.label ?? '--')
                  .join('\n')}
              </pre>
            </div>
          }
          placement="bottom-start"
        >
          <Typography style={{ fontWeight: 'bold', cursor: 'pointer' }}>
            ... a dalších {count - MAX_ROWS} položek. Celkem {count}.
          </Typography>
        </Tooltip>
      ) : (
        <></>
      )}
    </div>
  );
}

export function EsFileFields() {
  const { esFile } = useFormSelector((data: Document) => ({
    esFile: data.esFile,
  }));

  return (
    <FormPanel
      label={
        <FormattedMessage
          id="ES__DOCUMENT__DETAIL__ES_FILE_PANEL_TITLE"
          defaultMessage="Spis"
        />
      }
    >
      <FormTextField
        name="esFile.number.value"
        label={
          <FormattedMessage
            id="ES__DOCUMENT__DETAIL__FIELD_LABEL__FILE_NUMBER"
            defaultMessage="Spisová značka"
          />
        }
        disabled={true}
        after={
          esFile?.id && (
            <Redirect url={EvidenceBrowserUrl.ES_FILES_ALL} id={esFile.id} />
          )
        }
      />
      {esFile?.agenda === Agenda.COURT && (
        <>
          <FormCustomField
            name="esFile.proposers"
            disabled={true}
            label={
              <FormattedMessage
                id="ES__DOCUMENT__DETAIL__FIELD_LABEL__PROPOSERS"
                defaultMessage="Navrhovatel"
              />
            }
          >
            <FormattedList items={(esFile as CourtFile).proposers ?? []} />
          </FormCustomField>

          <FormCustomField
            disabled={true}
            label={
              <FormattedMessage
                id="ES__DOCUMENT_OUTGOING__DETAIL__FIELD_LABEL__OPPONENT"
                defaultMessage="Odpůrce"
              />
            }
          >
            <FormattedList items={(esFile as CourtFile).challengedActs ?? []} />
          </FormCustomField>
        </>
      )}
      {esFile?.agenda && [Agenda.INF, Agenda.SPR].includes(esFile?.agenda) && (
        <FormCustomField
          name="esFile.writers"
          label={
            <FormattedMessage
              id="ES__DOCUMENT__DETAIL__FIELD_LABEL__WRITERS"
              defaultMessage="Pisatel"
            />
          }
          disabled={true}
        >
          <TextArea
            disabled={true}
            value={(esFile as SprFile | InfFile).writers
              ?.map((writer) => writer.label)
              .join('\n')}
          />
        </FormCustomField>
      )}
    </FormPanel>
  );
}
